/*
|---------------------------------------------------------------------
| Board Vuex Mutations
|---------------------------------------------------------------------
|
| Synchronous operations for board store
|
*/
export default {
    /* ---------------------------------- NOTAC COBRO MUTATIONS --------------------------------- */

    setNotasCobro: (state, notas_cobro) => {
        state.notas_cobro = notas_cobro
    },

    setSelectedNotasCobro: (state, notas_cobro) => {
        state.notas_cobro_selected = notas_cobro
    },

}
